import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { DfEventService } from '@df/core/service/df-event';
import { Status } from '@df/core/status';
import { UiComponent } from '@df/ui/ui.component';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { WishlistStatus } from '../../../wishlist/wishlist.interface';
import {
    PRODUCT_CLOSE_PREVIEW_EVENT_NAME,
    PRODUCT_WISHLIST_OPEN_PREVIEW_EVENT_NAME,
    PRODUCT_WISHLIST_PREPARE_PREVIEW_EVENT_NAME,
    ProductEventData
} from '../../product.abstract';
import { ProductService } from '../../product.service';

@Directive()
export abstract class ProductViewWishlistAbstract extends UiComponent {
    @Input({ required: true })
    product!: ProductDecorator<IProductDataV2>;

    @Input()
    color?: number;

    @Input()
    listPosition?: number;

    protected override canDetach = true;

    readonly wishlistStatus = WishlistStatus;
    currentStatus?: WishlistStatus;
    isLoading = false;
    status = new Status();

    protected dfEventService = inject(DfEventService);
    protected elementRef = inject(ElementRef);
    protected renderer2 = inject(Renderer2);
    protected productService = inject(ProductService);
    protected app = inject(App);

    override ngOnInit(): void {
        this.subscriptions.add(
            this.dfEventService.success(event => {
                if (this.productService.canTriggerEvent(event, this.product, this.listPosition)) {
                    if (event.id === PRODUCT_WISHLIST_PREPARE_PREVIEW_EVENT_NAME) {
                        this.onPrepareEvent(event.data);
                    }

                    if (event.id === PRODUCT_WISHLIST_OPEN_PREVIEW_EVENT_NAME) {
                        this.onOpenEvent(event.data);
                    }

                    if (event.id === PRODUCT_CLOSE_PREVIEW_EVENT_NAME) {
                        this.onCloseEvent(event.data);
                    }
                }
            })
        );

        super.ngOnInit();
    }

    get showOptions() {
        return !this.isLoading && this.currentStatus === WishlistStatus.BeforeAdd;
    }

    get wishlist() {
        return this.app.customer.wishlist;
    }

    protected toggle(to = false) {
        this.renderer2[to ? 'addClass' : 'removeClass'](this.elementRef.nativeElement, 'is-open');
    }

    protected onPrepareEvent(data: ProductEventData) {
        this.toggle(true);
    }

    protected onOpenEvent(data: ProductEventData) {
        this.currentStatus = data.status;
        this.isLoading = !!data.loading;

        this.detectChanges();

        if (this.client.isL || this.client.isX) {
            this.toggle(true);
        } else if (data.status === WishlistStatus.AddSuccess) {
            this.toggle(true);
        }
    }

    protected onCloseEvent(data: ProductEventData) {
        this.currentStatus = undefined;
        this.isLoading = !!data.loading;

        this.detectChanges();

        this.toggle();
    }
}
